import React, { useEffect, useState } from "react";
import "react-notifications/lib/notifications.css";
import {
	NotificationContainer,
	NotificationManager,
} from "react-notifications";
import { useTimer } from "react-timer-hook"
import fire from "../../../helpers/db";
import { quiz as quizData } from "./data";
import Formsiswa from "./Formsiswa";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import MediaQuery from "react-responsive";

const Kuis = () => {
	const time = new Date();
	time.setSeconds(time.getSeconds()+2400);
	const {seconds, minutes, hours} = useTimer({expiryTimestamp: time,onExpire:()=>checkScore1()});
	const db = fire.firestore();
	const [siswa, setSiswa] = useState("");
	const [hasil, setHasil] = useState(false);
	
	const [currentIndex, setCurrentIndex] = useState(0);
	const [quiz, setQuiz] = useState(quizData);
	const [score, setScore] = useState({
		correct: 0,
		false: 0,
	});

	const userState = () => {
		const data = localStorage.getItem("user");
		const userobject = data !== null ? JSON.parse(data) : null;
		setSiswa(userobject);
	};

	useEffect(() => {
		userState();
	}, []);

	const { pertanyaan, soalgambar ,options } = quiz[currentIndex];

	const nextQuestion = () => {
		if (quiz.length - 1 === currentIndex) return;
		setCurrentIndex(currentIndex + 1);
	};
	const previousQuestion = () => {
		if (currentIndex === 0) return;
		setCurrentIndex(currentIndex - 1);
	};

	const selectOption = (indexSelected, indexSelectedOptions) => {
		setQuiz(
			quiz.map((item, index) =>
				index === indexSelected
					? {
							...item,
							selected: true,
							options: options.map((item, index) =>
								index === indexSelectedOptions
									? { ...item, selected: true }
									: { ...item, selected: false }
							),
					  }
					: item
			)
		);
	};
	const checkScore = () => {
		const questionAnswered = quiz.filter((item) => item.selected);
		let testAnswer = [];
		questionAnswered.forEach((item) =>
			item.options.forEach((data) => {
				if (data.selected) testAnswer.push(data);
			})
		);
		console.log(testAnswer);
		const questionCorrect = questionAnswered.filter((item) =>
			item.options.find(
				(option) => option.correct && option.selected === option.correct
			)
		);
		if (testAnswer.length < 20) {
			NotificationManager.error("Kamu harus mengisi semua jawaban", "", 1500);
		} else {
			setHasil(true);
			setScore({
				correct: questionCorrect.length,
				false: quiz.length - questionCorrect.length,
			});
			db.collection("evaluasi").add({
				nama: siswa.nama,
				sekolah: siswa.sekolah,
				nilai: questionCorrect.length * 5,
				picked: testAnswer,
			});
		}

	};
	const checkScore1 = () => {
		const questionAnswered = quiz.filter((item) => item.selected);
		let testAnswer = [];
		questionAnswered.forEach((item) =>
			item.options.forEach((data) => {
				if (data.selected) testAnswer.push(data);
			})
		);
		console.log(testAnswer);
		const questionCorrect = questionAnswered.filter((item) =>
			item.options.find(
				(option) => option.correct && option.selected === option.correct
			)
		);
	
			setHasil(true);
			setScore({
				correct: questionCorrect.length,
				false: quiz.length - questionCorrect.length,
			});
			db.collection("pretest").add({
				nama: siswa.nama,
				sekolah: siswa.sekolah,
				nilai: questionCorrect.length * 5,
				picked: testAnswer,
			});
		

	};
	return (
		<div>
			{siswa !== null ? (
				<div className="container">
					{hasil ? (
						<>
				<div className="row">
				<div className="col">
					<div
						className="card mt-2 border-success"
						style={{ borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
							className="card-header"
						>
							<h6 className="text-white text-center">Skor Evaluasi</h6>
						</div>
						<div className="card-body">
						<div className="text-center h1">{score.correct * 5}</div>
							<ol>
								<li>Nama Siswa : {siswa.nama}</li>
								<li>Kelas Siswa : {siswa.sekolah}</li>	
							</ol>
						</div>
						<div className="card-footer">
					{score.correct < 15 ? (<><div className="text-center h4 mt-1">Nilai Kamu di bawah KKM !!, Kamu harus lebih giat lagi ya &#128170;</div></>) 
					: 
					(<>
					<div className="text-center h4 mt-1">Nilai Kamu di atas KKM !! , Selamat ya &#128077;</div>
				
						<div className="text-center mt-2">
							<h6>Kamu telah menyelesaiakannya!!</h6>		
						</div>
					</>)
					}
						</div>
					</div>
				</div>
			</div>

						</>
					) : (
						<div className="container">
								<NotificationContainer/>
							<div className="d-flex justify-content-center"><h2>{hours}:{minutes}:{seconds}</h2></div>						
							<div className="row align-items-start">
								<div className="col"></div>
								<div className="col">
									<div
										className="card border-danger mt-2"
										style={{ width: "20rem" }}
									>
										<div className="card-body ">
											<div className="text-center">
												<h5 style={{ color: "orangered" }}>Keterangan</h5>
											</div>
											<div
												className=""
												style={{
													display: "flex",
													justifyContent: "space-between",
												}}
											>
												<div>
													<div
														style={{
															borderRadius: "10px",
															width: "50px",
															height: "50px",
															backgroundColor: "#00e64d",
														}}
													></div>
													<p style={{ color: "green" }}>Sudah dijawab</p>
												</div>
												<div>
													<div
														style={{
															borderRadius: "10px",
															width: "50px",
															height: "50px",
															backgroundColor: "orange",
														}}
													></div>
													<p style={{ color: "orange" }}>Soal sekarang</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col"></div>
							</div>
							<div className="card shadow  bg-body rounded mt-2">
							<MediaQuery maxWidth={1824} minWidth={476}>
								<div className="card-body" style={{ display: "flex",padding:'10', flexWrap:"wrap" }}>
									{quiz.map((item, index) => (
										<div
											className="border"
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												height: 40,
												width: 40,
												marginRight: 10,
												borderRadius: 8,
												backgroundColor:
													index === currentIndex
														? "orange"
														: item?.selected
														? "#00e64d"
														: "transparent",
												fontWeight: "bold",
												color: item?.selected ? "white" : "black",
											}}
											onClick={() => setCurrentIndex(index)}
										>
											{index + 1}
										</div>
									))}
								</div>
								</MediaQuery>
								<MediaQuery maxWidth={475} >
								<div className="card-body" style={{ display: "flex",padding:'10', flexWrap:"wrap" }} >
								
									{quiz.map((item, index) => (
										<div
											className="border"
											style={{
												display: "flex",
												justifyContent:'center',
												alignItems: "center",
												height: 40,
												width: 40,
												marginRight: 10,
												borderRadius: 8,
												backgroundColor:
													index === currentIndex
														? "orange"
														: item?.selected
														? "#00e64d"
														: "transparent",
												fontWeight: "bold",
												color: item?.selected ? "white" : "black",
											}}
											onClick={() => setCurrentIndex(index)}
										>
											{index + 1}
										</div>
									))}
								</div>
								</MediaQuery>
							</div>

							<div className="card shadow  bg-body rounded mt-2">
								<div className="card-header">
									<div
										style={{
											position: "relative",
											display: "flex",
										}}
									>
										<p style={{textAlign:'justify',lineHeight:'35px'}}>{pertanyaan}</p>
									</div>
								</div>
								<div className="d-flex justify-content-center mx-auto mt-1">
										<TransformWrapper defaultScale={1}>
											<TransformComponent>
												<img
													style={{
														width: "380px",
														height: "280px",
														marginBottom: "1rem",
													}}
													src={`${soalgambar}`}
													alt="gamb1"
												/>
											</TransformComponent>
										</TransformWrapper>
									</div>
								<div className="card-body">
									{options.map((item, index) => (
										<div
											style={{
												display: "flex",
												fontSize: 18,
											}}
											key={index}
										>
											<div
												style={{
													height: 20,
													width: 20,
													borderRadius: 100,
													backgroundColor: item?.selected
														? "limegreen"
														: "lightgrey",
													cursor: "pointer",
													marginRight: 10,
													display: "flex",
													justifyContent: "center",
												}}
												onClick={() => selectOption(currentIndex, index)}
											/>
											{item.title}
										</div>
									))}
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									paddingTop: 15,
									marginBottom: "1.5rem",
								}}
							>
								<button
									className="btn btn-success col-sm-2"
									onClick={() => previousQuestion()}
									disabled={currentIndex === 0 ? true : false}
								>
									Previous
								</button>

								{quiz.length - 1 === currentIndex ? (
									<button
										className="btn btn-warning col-sm-2"
										onClick={() => checkScore()}
									>
										{" "}
										Finish{" "}
									</button>
								) : (
									<button
										className="btn btn-success col-sm-2"
										onClick={() => nextQuestion()}
									>
										Next{" "}
									</button>
								)}
							</div>
						</div>
					)}
				</div>
			) : (
				<Formsiswa palakao={(siswa) => setSiswa(siswa)}/>
			)}

			{/* div akhir */}
		</div>
	);
};

export default Kuis;
